export type NewsletterEditTab = 'settings' | 'content' | 'recipients' | 'tracking' | 'report';

export const NEWSLETTER_EDIT_TABS: readonly NewsletterEditTab[] = [
  'settings',
  'content',
  'recipients',
  'tracking',
  'report',
];

export const DEFAULT_NEWSLETTER_EDIT_TAB: NewsletterEditTab = 'content';

export const NEWSLETTER_BLOCKS_VIEW_QUERY = 'view';

export const NEWSLETTER_BLOCKS_VIEW_MODES = ['edit', 'preview', 'json'] as const;

export type NewsletterBlocksViewMode = (typeof NEWSLETTER_BLOCKS_VIEW_MODES)[number];

export const DEFAULT_NEWSLETTER_BLOCKS_VIEW: NewsletterBlocksViewMode = 'edit';

export function parseNewsletterEditTab(raw: string | undefined | null): NewsletterEditTab {
  return NEWSLETTER_EDIT_TABS.includes(raw as NewsletterEditTab)
    ? (raw as NewsletterEditTab)
    : DEFAULT_NEWSLETTER_EDIT_TAB;
}

export function parseNewsletterBlocksViewMode(
  raw: string | undefined | null,
): NewsletterBlocksViewMode {
  return NEWSLETTER_BLOCKS_VIEW_MODES.includes(raw as NewsletterBlocksViewMode)
    ? (raw as NewsletterBlocksViewMode)
    : DEFAULT_NEWSLETTER_BLOCKS_VIEW;
}

export function newsletterEditPath(
  id: string | number,
  tab: NewsletterEditTab = DEFAULT_NEWSLETTER_EDIT_TAB,
  options?: { view?: NewsletterBlocksViewMode | string | null },
): string {
  const path = `/outgoing-newsletters/${id}/${tab}`;
  const view = parseNewsletterBlocksViewMode(options?.view);
  if (view === DEFAULT_NEWSLETTER_BLOCKS_VIEW) return path;
  return `${path}?${NEWSLETTER_BLOCKS_VIEW_QUERY}=${view}`;
}
